import {Component, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {ToastType} from '../../models/toast-type';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'via-notification-indicator',
  templateUrl: './notification-indicator.component.html',
  styleUrls: ['./notification-indicator.component.scss'],
  providers: [],
  imports: [MatIconModule, MatButtonModule]
})
export class NotificationIndicatorComponent {
  snackBarRef = inject<MatSnackBarRef<NotificationIndicatorComponent>>(MatSnackBarRef);
  data = inject<{
    message: string;
    notificationType: ToastType;
    action: string;
    trace: string;
  }>(MAT_SNACK_BAR_DATA);

  notificationType: ToastType;
  message: string;
  trace: string;
  action: string;
  showTrace = false;

  // Expose enum to html template
  public get notificationTypeEnum(): typeof ToastType {
    return ToastType;
  }

  constructor() {
    const data = this.data;

    this.notificationType = data.notificationType;
    this.message = data.message;
    this.action = data.action;
    this.trace = data.trace;
  }

  dismissWithAction() {
    this.snackBarRef.dismissWithAction();
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
